import Headroom from 'headroom.js'

export default function header () {
  const header = document.querySelector('.header')
  const body = document.querySelector('body')
  const categoryNavToggle = document.querySelector('.js-category-nav-toggle')
  const categoryNav = document.querySelector('.category-nav-container')
  const infoNavToggle = document.querySelector('.js-info-nav-toggle')
  const infoNav = document.querySelector('.info-nav')
  const searchToggles = document.querySelectorAll('.js-search-toggle')
  const search = document.querySelector('.search-overlay')
  const searchInput = document.querySelector('.search-overlay input')

  const categoryNavVisible = () => body.classList.contains('category-nav-open')
  const infoNavVisible = () => body.classList.contains('info-nav-open')
  const searchVisible = () => body.classList.contains('search-overlay-open')

  const toggleCategoryNav = (isOpen) => {
    body.classList.toggle('category-nav-open', isOpen)
    categoryNavToggle.classList.toggle('active', isOpen)
    categoryNav.classList.toggle('visible', isOpen)
  }

  const toggleInfoNav = (isOpen) => {
    body.classList.toggle('info-nav-open', isOpen)
    infoNavToggle.classList.toggle('active', isOpen)
    infoNav.classList.toggle('visible', isOpen)
  }

  const toggleSearch = (isOpen) => {
    body.classList.toggle('search-overlay-open', isOpen)
    search.classList.toggle('visible', isOpen)
    if (isOpen) searchInput.focus()
  }

  /* Headroom */
  const headroom = new Headroom(header, {
    offset: 100,
  })
  headroom.init()

  /* Category Nav */
  categoryNavToggle.addEventListener('click', (ev) => {
    ev.preventDefault()
    if (infoNavVisible()) toggleInfoNav(false)
    toggleCategoryNav(!categoryNavVisible())
  })

  /* Info Nav */
  infoNavToggle.addEventListener('click', (ev) => {
    ev.preventDefault()
    if (categoryNavVisible()) toggleCategoryNav(false)
    toggleInfoNav(!infoNavVisible())
  })

  /* Search */
  searchToggles.forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault()
      if (infoNavVisible()) toggleInfoNav(false)
      if (categoryNavVisible()) toggleCategoryNav(false)
      toggleSearch(!searchVisible())
    })
  })

  /* Close Category Nav when clicking outside */
  categoryNav.addEventListener('click', (ev) => {
    if (ev.target === categoryNav) {
      toggleCategoryNav(false)
    }
  })

  /* Close category nav when pressing Escape key */
  document.addEventListener('keydown', (ev) => {
    if (categoryNavVisible() && ev.key === 'Escape') {
      toggleCategoryNav(false)
    }
  })
}
